export default __webpack_public_path__ + "static/media/suspension.843a2b09.svg";